import React from 'react';
import HeaderOne from '../../common/header/HeaderOne';
import BreadcrumbOne from '../../common/breadcrumb/BreadcrumbOne';
import AttorneySingleDetailsOne from '../../components/attorney-components/AttorneySingleDetailsOne';
import FooterOne from '../../common/footer/FooterOne';

const AttorneySingleOne = () => {
    return (
        <>
        <HeaderOne />

        <BreadcrumbOne 
            title="Attorney Details 1"
            rootUrl="/"
            parentUrl="Home"
            currentUrl="Attorney Details 1"
        />
        
        <AttorneySingleDetailsOne />
        
        <FooterOne />
        </>
    )
}
    
export default AttorneySingleOne;